import { windowSize$ } from '../../store/windowSize';
import { useBatchedSubject } from './useBatchedSubject';

export function useWindowSize() {
  return useBatchedSubject(windowSize$);
}
